import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
export class TdMediaService {
private _queryMap: Map<string, string> = new Map<string, string>();
private _querySources: {[key: string]: Subject<boolean>} = {};
private _queryObservables: {[key: string]: Observable<boolean>} = {};
/**
 * @param {?} _ngZone
 */
constructor(private _ngZone: NgZone) {
    this._queryMap.set('xs', '(max-width: 599px)');
    this._queryMap.set('gt-xs', '(min-width: 600px)');
    this._queryMap.set('sm', '(min-width: 600px) and (max-width: 959px)');
    this._queryMap.set('gt-sm', '(min-width: 960px)');
    this._queryMap.set('md', '(min-width: 960px) and (max-width: 1279px)');
    this._queryMap.set('gt-md', '(min-width: 1280px)');
    this._queryMap.set('lg', '(min-width: 1280px) and (max-width: 1919px)');
    this._queryMap.set('gt-lg', '(min-width: 1920px)');
    this._queryMap.set('xl', '(min-width: 1920px)');
    this._queryMap.set('landscape', 'landscape');
    this._queryMap.set('portrait', 'portrait');
    this._queryMap.set('print', 'print');

    let running: boolean = false;
    window.onresize = () => {
      // way to prevent the resize event from triggering the match media if there is already one event running already.
      if (!running) {
        running = true;
        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(() => {
            this._onResize();
            running = false;
          });
        } else {
          setTimeout(() => {
            this._onResize();
            running = false;
          }, 66);
        }
      }
    };
  }
/**
 * Used to evaluate whether a given media query is true or false given the current device's screen / window size.
 * @param {?} query
 * @return {?}
 */
public query(query: string): boolean {
    if (this._queryMap.get(query.toLowerCase())) {
      query = this._queryMap.get(query.toLowerCase());
    }
    return this._ngZone.run(() => {
      return window.matchMedia(query).matches;
    });
  }
/**
 * Registers a media query and returns an [Observable] that will re-evaluate and
 * return if the given media query matches on window resize.
 * Note: don't forget to unsubscribe from [Observable] when finished watching.
 * @param {?} query
 * @return {?}
 */
public registerQuery(query: string): Observable<boolean> {
    if (this._queryMap.get(query.toLowerCase())) {
      query = this._queryMap.get(query.toLowerCase());
    }
    if (!this._querySources[query]) {
      this._querySources[query] = new Subject<boolean>();
      this._queryObservables[query] = this._querySources[query].asObservable();
    }
    return this._queryObservables[query];
  }
/**
 * Trigger a match media event on all subscribed observables.
 * @return {?}
 */
public broadcast(): void {
    this._onResize();
  }
/**
 * @return {?}
 */
private _onResize(): void {
    for (let /** @type {?} */ query in this._querySources) {
      this._ngZone.run(() => {
        this._matchMediaTrigger(query);
      });
    }
  }
/**
 * @param {?} query
 * @return {?}
 */
private _matchMediaTrigger(query: string): void {
    this._querySources[query].next(window.matchMedia(query).matches);
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
];
}

function TdMediaService_tsickle_Closure_declarations() {
/** @type {?} */
TdMediaService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdMediaService.ctorParameters;
/** @type {?} */
TdMediaService.prototype._queryMap;
/** @type {?} */
TdMediaService.prototype._querySources;
/** @type {?} */
TdMediaService.prototype._queryObservables;
/** @type {?} */
TdMediaService.prototype._ngZone;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
